import React, { useContext } from "react";
import { Avatar, message, Typography, Button } from "antd";
import { Header } from "antd/es/layout/layout";
import arrow from "../../assets/svgs/header-icon/arrow-down.svg";
import { Menu, Dropdown } from "antd";
import ArrowBackIcon from "../../assets/svgs/svg-icons/ArrowBackIcon";
import { MenuOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { logout } from './../../redux/actions/auth';
import { capitalizeWords, formatStr, sleep } from './../../utils/utils';
import { useNavigate } from "react-router-dom";
import { DrawerContext } from "../../pages/MainPage/Main";

const BpsHeader = ({ page, showArrow }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const drawerCtx = useContext(DrawerContext);

  //const { showOverview, setShowOverview } = useContext(BpsContext);

  const onLogoutRequest = () => {
    dispatch(logout()).then((response) => {
      message.success(response?.message ?? 'Logged out successfully');
      sleep(1000).then(() => {
        navigate('/');
      });
    }).catch(err => message.error(err));
  };

  const menu = (
    <Menu selectable>
      <Menu.Item key={Math.random().toString()}>
        <a
          target="_self"
          rel="noopener noreferrer"
          onClick={onLogoutRequest}
        >
          Logout
        </a>
      </Menu.Item>
    </Menu>
  );

  return (
    <Header className="Header">
      <div className="bps-header__title">
        {drawerCtx?.isMobile && (
          <Button
            className="bps-header__hamburger"
            icon={<MenuOutlined />}
            onClick={drawerCtx?.openDrawer}
          />
        )}
        {/* {showArrow && (
          <ArrowBackIcon onClick={() => setShowOverview(!showOverview)} />
        )} */}
        {showArrow && (
          <ArrowBackIcon onClick={() => navigate(-1)} />
        )}
        <Typography.Text>{capitalizeWords(formatStr(page))}</Typography.Text>
      </div>
      <div className="bps-header__profile">
        <Avatar className="bps-header__profile_name">AA</Avatar>
        <Dropdown overlay={menu}>
          <a className="ant-dropdown-link" href="#">
            <img src={arrow} alt="/" />
          </a>
        </Dropdown>
      </div>
    </Header>
  );
};

BpsHeader.defaultProps = {
  showArrow: false,
};

export default BpsHeader;